<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.code", :label="translations.label.id", :disabled="true")
          v-col(cols="12" sm="6" md="4")
            BaseSelectField(rules="required", :items="connectors" v-model="form.connector", :label="translations.label.connector")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(v-model="form.connectorId", :label="translations.label.connectorId")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(v-model="form.connectorKey", :label="translations.label.connectorKey")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.key", :label="translations.label.key")
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseChipSelectField(rules="required", :multiple="false", :items="jurisdictions" v-model="form.jurisdiction", :label="translations.label.jurisdiction")
          v-col(cols="12" sm="6" md="4")
            v-select(:label="translations.label.accountManager"  :items="accountManagerList" v-model="form.am")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Fantasy:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.fantasyenabled", :label="translations.label.fantasyenabled")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseChipSelectField(v-if="form.fantasyenabled", rules="required", :items="competitions" v-model="form.competition", :label="translations.label.competition")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Host:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="required|host" v-model="form.casinoApi", :label="translations.label.casinoApi")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="required|host" v-model="form.sportsApi", :label="translations.label.sportsApi")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.bonusApi", :label="translations.label.bonusApi")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="required|host" v-model="form.lobby", :label="translations.label.lobbyURL")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.cashier", :label="translations.label.cashier")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.virtualsports", :label="translations.label.virtualsports")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.sportsbook", :label="translations.label.sportsbook")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Invoice:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.invoice.name", :label="translations.label.invoice.name")
                v-col.py-0(cols="12" sm="6")
                  BaseTextAreaField(rules="required" v-model="form.invoice.address", :label="translations.label.invoice.address")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.invoice.vat", :label="translations.label.invoice.vat")
                v-col.py-0(cols="12" sm="6")
                  //- BaseFloatField(v-model="form.invoice.tax" :label="translations.label.invoice.tax" :required="true" min="0" max="100" decimals="2")
                  BaseTextField(rules="required|numeric|min_value:0" v-model="form.invoice.tax", :label="translations.label.invoice.tax")
                  //- BaseTextField(rules="required" v-model="form.invoice.tax" :label="translations.label.invoice.tax")
                v-col.py-0(cols="12" sm="6")
                  BasePhoneField(rules="required" v-model="form.invoice.phone", :label="translations.label.invoice.phone")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required|email" v-model="form.invoice.email", :label="translations.label.invoice.email")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend {{ translations.label.config.title }}:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.cl", :label="translations.label.config.cl")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.oi", :label="translations.label.config.oi")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.raf", :label="translations.label.config.raf")
                  BaseTextField(v-if="form.cfg.raf", rules="required|numeric|max_value:100" v-model="form.cfg.rafpct", :label="translations.label.config.rafpercen")
                v-col(cols="12" sm="6" md="4")
                  v-checkbox(v-model="form.cfg.retail", :label="translations.label.config.retail")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend {{ translations.label.sms.title }}:
              v-row
                v-col(cols="12" sm="6" md="4")
                  v-checkbox(v-model="form.sms.enabled", :label="translations.label.sms.enabled")
                v-col(cols="12" sm="6" md="4" v-if="form.sms.enabled")
                  BaseTextField(rules="required" v-model="form.sms.origin", :label="translations.label.sms.origin")
                v-col(cols="12" sm="6" md="4" v-if="form.sms.enabled")
                  BaseTextField(rules="required" v-model="form.sms.user", :label="translations.label.sms.user")
                v-col(cols="12" sm="6" md="4" v-if="form.sms.enabled")
                  BasePasswordField(rules="required" v-model="form.sms.password", :label="translations.label.sms.password")
        v-row
          v-col(cols="12").py-4
            v-expansion-panels(accordion)
              v-expansion-panel
                v-expansion-panel-header
                  p.title.ma-0 {{ translations.label.extrafields }}
                v-expansion-panel-content
                  v-divider.mb-4
                  BaseDynamicField(v-model="form.params")
        v-row
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.buttons.edit }}
</template>

<script>

  export default {
    name: "OperatorEdit",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      competitions: {
        type: Array,
        default: function(){
          return []
        }
      },
      operator:{
        type: Object,
        default: function(){
          return {}
        }
      },
      connectors: {
        type: Array,
        default: function(){
          return []
        }
      },
      jurisdictions: {
        type: Array,
        default: function(){
          return []
        }
      },
      accountManagerList: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form: {
        name: '',
        code: '',
        fantasyenabled: false,
        competition: null,
        connector: '',
        connectorId: '',
        connectorKey: '',
        key: '',
        casinoApi: '',
        sportsApi: '',
        bonusApi: '',
        lobby: '',
        cashier: '',
        virtualsports: '',
        sportsbook: '',
        jurisdiction: null,
        am: '',
        invoice: {
          name: '',
          address: '',
          vat: '',
          tax: '',
          phone: '',
          email: '',
        },
        cfg: {
          cl: false,
          oi: false,
          retail: false,
          raf: false,
          rafpct: '0',
        },
        sms: {
          origin: '',
          enabled: false,
          user: '',
          password: '',
        },
        params: [],
      },
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editOperator.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editOperator.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200){
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          _id: this.operator._id,
          data: {
            name: this.form.name,
            code: this.form.code,
            connector: this.form.connector,
            key: this.form.key,
            casinoApi: this.form.casinoApi,
            sportsApi: this.form.sportsApi,
            url: {
              lobby: this.form.lobby,
            },
            jurisdiction: this.form.jurisdiction.value,
            invoice: {
              name: this.form.invoice.name,
              address: this.form.invoice.address,
              vat: this.form.invoice.vat,
              tax: this.form.invoice.tax,
              phone: this.form.invoice.phone,
              email: this.form.invoice.email,
            },
            cfg: {
              cl: this.form.cfg.cl,
              oi: this.form.cfg.oi,
              raf: this.form.cfg.raf,
              retail: this.form.cfg.retail,
            },
            sms: {
              enabled: this.form.sms.enabled,
            },
          },
        };
        if(this.form.fantasyenabled){
          formSend.data.competition = this.form.competition.map(comp => ( comp.value ));
        }
        if(this.form.cashier != ''){
          formSend.data.url.cashier = this.form.cashier;
        }
        if(this.form.virtualsports != ''){
          formSend.data.url.virtualsports = this.form.virtualsports;
        }
        if(this.form.sportsbook != ''){
          formSend.data.url.sportsbook = this.form.sportsbook;
        }
        if(this.form.bonusApi != ''){
          formSend.data.bonusApi = this.form.bonusApi;
        }
        if(this.form.am != undefined  && this.form.am != ''){
          formSend.data.am = this.form.am;
        }
        if(this.form.connectorId != ''){
          formSend.data.connectorId = this.form.connectorId
        }
        if(this.form.connectorKey != ''){
          formSend.data.connectorKey = this.form.connectorKey
        }
        if(this.form.cfg.raf){
          formSend.data.cfg.rafpct = parseInt(this.form.cfg.rafpct);
        }
        if(this.form.sms.enabled){
          formSend.data.sms.origin = this.form.sms.origin;
          formSend.data.sms.user = this.form.sms.user;
          formSend.data.sms.password = this.form.sms.password;
        }
        if (this.form.params.length){
          formSend.data.params = {};
          this.form.params.forEach((item) => {
            formSend.data.params[item.key] = item.value;
          });
        }
        this.$store.dispatch('editOperator', formSend);
      },
      setFields(){
        this.form.name = this.operator.name;
        this.form.code = this.operator.code;
        this.form.fantasyenabled = this.operator.competition.length > 0;
        this.form.competition = this.operator.competition;
        this.form.connector = this.operator.connector;
        this.form.connectorId = this.operator.connectorId;
        this.form.connectorKey = this.operator.connectorKey;
        this.form.key = this.operator.key;
        this.form.casinoApi = this.operator.casinoApi;
        this.form.sportsApi = this.operator.sportsApi;
        this.form.bonusApi = this.operator.bonusApi;
        this.form.lobby = this.operator.url.lobby;
        this.form.cashier = this.operator.url.cashier;
        this.form.virtualsports = this.operator.url.virtualsports;
        this.form.sportsbook = this.operator.url.sportsbook;
        this.form.jurisdiction = [...this.operator.jurisdiction];
        this.form.am = this.operator.am;
        this.form.invoice.name = this.operator.invoice.name;
        this.form.invoice.address = this.operator.invoice.address;
        this.form.invoice.vat = this.operator.invoice.vat;
        this.form.invoice.tax = this.operator.invoice.tax;
        this.form.invoice.phone = this.operator.invoice.phone;
        this.form.invoice.email = this.operator.invoice.email;
        this.form.cfg.cl = this.operator.cfg.cl;
        this.form.cfg.oi = this.operator.cfg.oi;
        this.form.cfg.retail = this.operator.cfg.retail;
        this.form.cfg.raf = this.operator.cfg.raf;
        this.form.cfg.rafpct = this.operator.cfg.rafpct;
        this.form.sms.origin = this.operator.sms.origin;
        this.form.sms.enabled = this.operator.sms.enabled;
        this.form.sms.user = this.operator.sms.user;
        this.form.sms.password = this.operator.sms.password;
        this.form.params = this.changeObjectToArray(this.provider.params);
      },
      changeObjectToArray(objarr){
        if(objarr != undefined){
          let arr = [];
          Object.keys(objarr).forEach(keyitem=>{
            arr.push({
              key: keyitem,
              value: objarr[keyitem]
            });
          })
          return arr;
        } else {
          return [];
        }
      },
    }
  }
</script>

<style lang="sass">
</style>